import { useLocation, useNavigate } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

const ThankYouPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { plan, paymentId } = location.state || {};

  const planName = plan?.name || "Subscription Plan";
  const planPrice = plan?.pricing ?? plan?.price ?? 0;

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/30 p-4">
      <div className="w-full max-w-lg text-center space-y-8">
        {/* Success Icon */}
        <div className="flex justify-center">
          <div className="rounded-full border-2 border-green-600 p-2">
            <CheckCircle
              className="w-10 h-10 text-green-600"
              strokeWidth={1.5}
            />
          </div>
        </div>

        {/* Heading */}
        <div className="space-y-2">
          <h1 className="text-3xl font-bold text-foreground">
            Thank you for your purchase!
          </h1>
          <p className="text-muted-foreground">
            You should receive an order confirmation email shortly.
          </p>
        </div>

        {/* Order Details Card */}
        <div className="bg-background rounded-lg border p-6">
          <div className="flex items-center justify-between">
            <span className="text-base font-medium text-foreground">
              {planName}
            </span>
            <span className="text-base font-semibold text-green-700">
              ₹{planPrice}
            </span>
          </div>
        </div>

        {/* Totals */}
        <div className="space-y-2 px-6">
          <div className="flex justify-between text-muted-foreground text-sm">
            <span>Subtotal</span>
            <span>₹{planPrice}</span>
          </div>
          <div className="flex justify-between text-foreground font-semibold text-base">
            <span>Total:</span>
            <span>₹{planPrice}</span>
          </div>
        </div>

        {/* Payment ID */}
        {paymentId && (
          <p className="text-xs text-muted-foreground">
            Payment ID: {paymentId}
          </p>
        )}

        {/* Action Button */}
        <Button
          variant="outline"
          onClick={() => navigate("/my-subscription")}
          className="mt-4"
        >
          Back to Subscriptions
        </Button>
      </div>
    </div>
  );
};

export default ThankYouPage;
